import { QuizDto } from '../../../models/dtos/quiz.dto';
import axios from '../../axios';

export default async function getActiveQuizRequest(): Promise<QuizDto> {
  const response = await axios.get<QuizDto>(
    `${process.env.REACT_APP_BASE_URL}/quiz/active`
  );
  return response.data;
}
